export default "__VITE_ASSET__DMOXTDG1__"